import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { ReactComponent as NoComboIcon } from 'app/assets/img/iconNoCombo.svg';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../App/slice/selectors';
interface INoDataProps {
  boxNoDataStyle?: CSSProperties;
}
const NoDataComponent = ({ boxNoDataStyle }: INoDataProps) => {
  const translations = useSelector(selectTranslations);
  return (
    <BoxNoOrder style={boxNoDataStyle}>
      <NoComboIcon />
      {translations?.['b2b.txt.noDataComboHoliday'] ?? ''}
    </BoxNoOrder>
  );
};
export default NoDataComponent;
const BoxNoOrder = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  padding: 20px;
`;
